<template>
  <div class="container mescroll-touch">
    <div class="header">
      <div class="searchContent">
        <div class="searchBox">
          <input class="searchInput" type="text" v-model="searchValue" placeholder="请输入关键字搜索" @keydown.enter="search" />
          <img class="closeIcon" @click="clearInput" src="@/assets/images/delete_reseach_icon@2x.png" />
        </div>
        <span class="searchBtn" @click="search">搜索</span>
      </div>
      <div class="header_title">
        <!-- <span class="searchHistory" v-show="!searchKey">搜索历史</span> -->
        <span class="searchHistory" v-show="searchKey">您的关键字“{{searchKey}}”搜索结果：</span>
        <!-- <img class="clearIcon" v-show="!searchKey" src="@/assets/images/delete_ss_icon@2x.png" @click="clearSearch" /> -->
      </div>
    </div>
    <div class="content" v-show="!searchKey">
      <div class="popularSearch" v-if="PopularList.length > 0">
        <div class="popularTitle">
          <div class="popularTitle_left">
            <img src="@/assets/images/hot_comm_icon@2x.png" />
            <span>热门搜索</span>
          </div>
          <span class="refresh" @click="getPopularList">刷新</span>
        </div>
        <div class="popularList">
          <span v-for="(item, index) in PopularList" :key="index" @click="popularSearch(item.Name)">{{item.Name}}</span>
        </div>
      </div>

      <div class="popularSearch">
        <div class="popularTitle">
          <div class="popularTitle_left">
            <!-- <img src="@/assets/images/hot_comm_icon@2x.png" /> -->
            <span>搜索历史</span>
          </div>
          <van-icon class="clearIcon" name="delete-o" @click="clearSearch" />
        </div>
        <div class="popularList">
          <span v-for="(item, index) in HistoryList" :key="index" @click="historySearch(item.SearchKey)">{{item.SearchKey}}</span>
        </div>
      </div>
    </div>
    
    <div class="tabBar" v-show="searchKey">
      <span :class="{'tabActive': searchType == null}" @click="changeSearchType(null)">综合</span>
      <span :class="{'tabActive': searchType == 1}" @click="changeSearchType(1)">医生</span>
      <span :class="{'tabActive': searchType == 2}" @click="changeSearchType(2)">内容</span>
    </div>
    <mescroll-vue v-show="searchKey" ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div id="dataList" v-if="searchKey">
        <template v-if="searchType == null">
          <div class="comprehensiveBox" v-if="comprehensiveList2.length > 0">
            <div class="comprehensiveTitle">
              <span class="title">医生</span>
              <span class="more" @click="changeSearchType(1)">更多<van-icon name="arrow" /></span>
            </div>
            <div class="comprehensiveList1">
              <div class="doctorItem" v-for="(item, index) in comprehensiveList2" :key="index">
                <div class="doctorIcon" @click="toPersonal(item.Id)">
                  <img src="@/assets/images/headSculpture1.png" alt="" />
                </div>
                <div class="doctorInfo">
                  <div>
                    <span class="doctorName">{{ item.UserName }}</span>
                    <span class="doctorPosition">{{ item.PositionalName }}</span>
                  </div>
                  <div class="hospital">
                    <span>{{ item.HospitalTitle }}</span>
                    <span>{{ item.SubjectName }}</span>
                  </div>
                </div>
                <template v-if="item.Id != userInfo.Id">
                  <div class="followBtn followBtn1" v-if="item.State == 1" @click="followersUnFollow(index)">已关注</div>
                  <div class="followBtn" v-else @click="followersFollow(index)">关注</div>
                </template>
              </div>
            </div>
          </div>
          <div class="comprehensiveBox" v-if="comprehensiveList1.length > 0">
            <div class="comprehensiveTitle">
              <span class="title">内容</span>
              <!-- <span class="more" @click="changeSearchType(2)">更多<van-icon name="arrow" /></span> -->
            </div>
            <div class="comprehensiveList2">
              <waterfall :col="2" :gutterWidth="10" :data="list">
              <template>
              <div class="list" v-for="(item, index) in comprehensiveList1" :key="index" @click="toContentPage(item.Id, item.Type)">
                <div class="item_img">
                  <img class="item_cover" :src="item.Thumbnail" />
                  <img class="playIcon" src="@/assets/images/play_comm_icon@2x.png" />
                  <span class="activityLabel" v-if="item.Type == 4">系列活动</span>
                </div>
                <div class="item_content">
                  <span class="item_title van-multi-ellipsis--l2">{{item.Title}}</span>
                  <div class="doctor_info" v-if="item.Speaker || item.HospitalName">
                    {{item.Speaker}} <span v-if="item.HospitalName">|</span> {{item.HospitalName}}
                  </div>
                </div>
              </div>
              </template>
              </waterfall>
              <p class="waterfall_more" @click="changeSearchType(2)">查看更多<van-icon name="arrow" /></p>
            </div>
          </div>
        </template>
        <template v-else-if="searchType == 1">
          <div class="doctorItem" v-for="(item, index) in list" :key="index">
            <div class="doctorIcon" @click="toPersonal(item.Id)">
              <img src="@/assets/images/headSculpture1.png" alt="" />
            </div>
            <div class="doctorInfo">
              <div>
                <span class="doctorName">{{ item.UserName }}</span>
                <span class="doctorPosition">{{ item.PositionalName }}</span>
              </div>
              <div class="hospital">
                <span>{{ item.HospitalTitle }}</span>
                <span>{{ item.SubjectName }}</span>
              </div>
            </div>
            <template v-if="item.Id != userInfo.Id">
              <div class="followBtn followBtn1" v-if="item.State == 1" @click="doctorFollowersUnFollow(index)">已关注</div>
              <div class="followBtn" v-else @click="doctorFollowersFollow(index)">关注</div>
            </template>
          </div>
        </template>
        <template v-else>
          <waterfall :col="2" :gutterWidth="10" :data="list">
            <template>
              <div class="list" v-for="(item, index) in list" :key="index" @click="toContentPage(item.Id, item.Type)">
                <div class="item_img">
                  <img class="item_cover" :src="item.Thumbnail" />
                  <img class="playIcon" src="@/assets/images/play_comm_icon@2x.png" />
                  <span class="activityLabel" v-if="item.Type == 4">系列活动</span>
                </div>
                <div class="item_content">
                  <span class="item_title van-multi-ellipsis--l2">{{item.Title}}</span>
                  <div class="doctor_info" v-if="item.Speaker || item.HospitalName">
                    {{item.Speaker}} <span v-if="item.HospitalName">|</span> {{item.HospitalName}}
                  </div>
                </div>
              </div>
            </template>
          </waterfall>
        </template>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import { mapState } from 'vuex'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  name: 'Search',
  data() {
    return {
      actionId: '',
      searchValue: '',
      searchKey: '',
      HistoryList: [],
      PopularList: [],
      searchType: null,
      list: [],
      comprehensiveList1: [],
      comprehensiveList2: [],
      PageIndex: 0,
      PageSize: 10,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 10 //每页数据条数,默认10
				},
        noMoreSize: 0,
        htmlNodata: '',
				// htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: `很抱歉！<br/>似乎找不到任何与您搜索内容匹配的结果`, // 提示
        },
			},
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue
  },
  computed: {
    ...mapState(['userInfo'])
  },
  watch: {
    searchValue(newval) {
      if (newval == '') {
        this.searchKey = '';
      }
    }
  },
  activated(){
    this.BuriedPoint(6, '搜索页', '', '/search', this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    this.mescroll.setBounce(false);
    this.mescroll.scrollTo(this.mescroll.preScrollY, 0);
  },
  deactivated() {
    this.mescroll.setBounce(true);
  },
  created() {
    this.getHistoryList();
    this.getPopularList();
  },
  methods: {
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      if(this.searchValue) {
        this.getList(page.num, page.size);
      }
		},
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetSearch', {
          KeyWords: this.searchValue,
          Type: this.searchType,
          CSId: this.actionId,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize
        }).then((res) => {
          if(this.searchType == null) {
            this.comprehensiveList1 = res.Data.List ? res.Data.List : [];
            this.comprehensiveList2 = res.Data.List2 ? res.Data.List2 : [];
            this.$nextTick(() => {
              if(res.Data.List) {
                this.mescroll.endSuccess(this.comprehensiveList1.length);
              } else if(res.Data.List2) {
                this.mescroll.endSuccess(this.comprehensiveList2.length);
              } else {
                this.mescroll.endSuccess(0);
              }
            })
          } else if(this.searchType == 1) {
            let arr = res.Data.List2 ? res.Data.List2 : [];
            // 如果是第一页需手动置空列表
            if (PageIndex === 1) this.list = []
            // 把请求到的数据添加到列表
            this.list = this.list.concat(arr);
            // 数据渲染成功后,隐藏下拉刷新的状态
            this.$nextTick(() => {
              this.mescroll.endSuccess(arr.length)
            })
          } else if(this.searchType == 2) {
            let arr = res.Data.List ? res.Data.List : [];
            // 如果是第一页需手动置空列表
            if (PageIndex === 1) this.list = []
            // 把请求到的数据添加到列表
            this.list = this.list.concat(arr);
            // 数据渲染成功后,隐藏下拉刷新的状态
            this.$nextTick(() => {
              this.mescroll.endSuccess(arr.length)
            })
          }
        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr()
        })
      }, 200);
    },
    getHistoryList() {
      this.$axios.get('/Api/api/Web/Cus_Search/GetCus_SearchByCustomerId').then(res => {
        // this.HistoryList = res.Data.List;
        this.HistoryList = this.duplicate(res.Data.List, 'SearchKey');
      })
    },
    getPopularList() {
      this.$axios.post('/Api/api/Web/Cus_Search/GetHWList').then(res => {
        this.PopularList = res.Data;
      })
    },
    clearInput() {
      this.searchValue = '';
    },
    search() {
      if(this.searchValue) {
        this.searchKey = this.searchValue;
        this.addSearchHistory(this.searchValue);
        this.BuriedPoint(2, this.searchValue, '', '').then(res => {
          this.actionId = res.Data;
          this.searchType = null;
          this.list = [];
          this.comprehensiveList1 = [];
          this.comprehensiveList2 = [];
          this.mescroll.resetUpScroll() // 刷新列表数据
          // this.getList();
        });
      }
    },
    addSearchHistory(searchValue) {
      this.$axios.post('/Api/api/Web/Cus_Search/AddCus_Search?SearchKey=' + searchValue).then(res => {
        this.getHistoryList();
      })
    },
    clearSearch() {
      this.$axios.post('/Api/api/Web/Cus_Search/ClearCus_SearchByCustomerId').then(() => {
        this.getHistoryList();
      })
    },
    historySearch(searchValue) {
      this.searchValue = searchValue;
      this.searchKey = searchValue;
      this.addSearchHistory(this.searchValue);
      this.BuriedPoint(2, this.searchValue, '', '').then(res => {
        this.actionId = res.Data;
        this.searchType = null;
        this.list = [];
        this.comprehensiveList1 = [];
        this.comprehensiveList2 = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
      });
    },
    popularSearch(searchValue) {
      this.searchValue = searchValue;
      this.searchKey = searchValue;
      this.addSearchHistory(this.searchValue);
      this.BuriedPoint(2, this.searchValue, '', '').then(res => {
        this.actionId = res.Data;
        this.searchType = null;
        this.list = [];
        this.comprehensiveList1 = [];
        this.comprehensiveList2 = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
      });
    },
    changeSearchType(type) {
      type ? this.mescrollUp.htmlNodata = '<p class="upwarp-nodata">-- END --</p>' : this.mescrollUp.htmlNodata = '';
      if(type != this.searchType) {
        this.searchType = type;
        this.list = [];
        this.comprehensiveList1 = [];
        this.comprehensiveList2 = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
      }
    },
    toPersonal(id) {
      this.$router.push({
        path: 'Personal',
        query: {
          id: id
        }
      });
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id,
            sourceType: 1,
            sourceId: this.actionId
          }
        });
      } else if(type == 4) {
        this.$router.push({
          path: 'activityDetails',
          query: {
            id: id,
            sourceType: 1,
            sourceId: this.actionId
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type,
            sourceType: 1,
            sourceId: this.actionId
          }
        });
      }
    },
    followersFollow(index) {
      this.$axios.post('/Api/Api/Web/Customer/AddUA?auid=' + this.comprehensiveList2[index].Id).then((res) => {
        this.$set(this.comprehensiveList2[index], 'State', 1);
      });
    },
    followersUnFollow(index) {
      this.$axios.post('/Api/Api/Web/Customer/UpdateUA?id=' + this.comprehensiveList2[index].Id).then((res) => {
        this.$set(this.comprehensiveList2[index], 'State', 0);
      });
    },
    doctorFollowersFollow(index) {
      this.$axios.post('/Api/Api/Web/Customer/AddUA?auid=' + this.list[index].Id).then((res) => {
        this.$set(this.list[index], 'State', 1);
      });
    },
    doctorFollowersUnFollow(index) {
      this.$axios.post('/Api/Api/Web/Customer/UpdateUA?id=' + this.list[index].Id).then((res) => {
        this.$set(this.list[index], 'State', 0);
      });
    },
    duplicate(arr, key) {
      const map = new Map()
      return arr.filter((item) => !map.has(item[key] + '') && map.set(item[key] + '', 1))
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // background-image: url('../../assets/images/bg_comm_png@2x.png');
  // background-repeat: no-repeat;
  // background-size: contain;
  background-color: #F8F8F8;
  .header {
    padding: 5px 12px;
    background-color: #EB1701;
    .searchContent {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .searchBtn {
        display: block;
        margin-left: 12px;
        height: 30px;
        line-height: 30px;
        border-radius: 30px;
        font-size: 14px;
        padding: 0 10px;
        background-color: #FFFFFF;
        color: #564C47;
      }
    }
    .searchBox {
      display: flex;
      flex: 1;
      align-items: center;
      height: 30px;
      line-height: 30px;
      border-radius: 30px;
      background-color: #FFFFFF;
      padding: 0 15px;
      .closeIcon {
        width: 15px;
        height: 15px;
      }
      .searchInput {
        flex: 1;
        border: none;
        margin-right: 6px;
        background-color: transparent;
      }
    }
    .header_title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      .searchHistory{
        font-size: 16px;
        color: #FFFFFF;
      }
      .clearIcon {
        width: 14px;
        height: 14px;
      }
    }
  }
  .content {
    min-height: 100px;
    margin-top: 1px;
    padding: 12px;
    background-color: #F8F8F8;
    border-radius: 12px 12px 0 0;
    .historyList {
      margin: 10px 0;
      span {
        text-align: center;
        min-width: 30px;
        display: inline-block;
        height: 33px;
        line-height: 33px;
        border-radius: 33px;
        padding: 0 10px;
        font-size: 12px;
        color: #666666;
        background-color: #FFFFFF;
        border: 1px solid #CCCCCC;
        margin: 0 10px 10px 0;
      }
    }
    .popularSearch {
      background-color: #FFFFFF;
      border-radius: 10px;
      padding: 15px;
      margin-bottom: 15px;
      .popularTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #CCCCCC;
        padding-bottom: 8px;
        .popularTitle_left {
          span {
            font-size: 15px;
            color: #333333;
            font-weight: bold;
            margin: 0 5px;
          }
          img {
            width: 12px;
          }
        }
        .refresh {
          font-size: 12px;
          color: #CCCCCC;
        }
        .clearIcon {
          font-size: 16px;
          color: #CCCCCC;
          margin-top: 3px;
        }
      }
      .popularList {
        margin-top: 5px;
        span {
          display: inline-block;
          min-width: 30px;
          height: 33px;
          line-height: 33px;
          border-radius: 33px;
          text-align: center;
          padding: 0 10px;
          font-size: 12px;
          color: #666666;
          background-color: #FFFFFF;
          border: 1px solid #CCCCCC;
          margin: 5px;
        }
      }
    }
  }
  
  .tabBar {
    height: 34px;
    background: #FFFFFF;
    padding: 0 15px;
    font-size: 14px;
    span {
      position: relative;
      display: inline-block;
      color: #666666;
      margin-right: 30px;
      margin-top: 8px;
    }
    .tabActive {
      top: -3px;
      font-size: 15px;
      color: #333333;
      font-weight: bold;
    }
    .tabActive::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -3px;
      width: 100%;
      height: 3px;
      border-radius: 3px;
      background-color: #E92E1B;
    }
  }
  .comprehensiveBox {
    box-sizing: border-box;
    .comprehensiveTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;
      .title {
        font-size: 15px;
        color: #333333;
      }
      .more {
        font-size: 12px;
        color: gray;
      }
    }
  }
  .comprehensiveBox:first-of-type {
    margin-bottom: 20px;
  }
  .doctorItem {
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
    padding: 8px 20px;
    border-radius: 10px;
    .doctorIcon {
      width: 53px;
      height: 53px;
      background: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
      border-radius: 50%;
      box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 3px 0px;
      margin-right: 15px;
      img {
        position: relative;
        top: 1.5px;
        left: 1.5px;
        display: block;
        width: 50px;
        height: 50px;
      }
    }
    .doctorInfo {
      flex: 1;
      .doctorName {
        font-size: 14px;
        font-weight: bold;
        color: #4D4D4D;
      }
      .doctorPosition {
        font-size: 12px;
        color: #808080;
        margin-left: 10px;
      }
      .hospital {
        font-size: 12px;
        color: #646464;
        margin-top: 5px;
        span {
          margin-right: 6px;
        }
      }
    }
    .followBtn {
      width: 55px;
      height: 26px;
      line-height: 26px;
      border-radius: 26px;
      text-align: center;
      background-color: #E92E1B;
      font-size: 13px;
      color: #FFFFFF;
    }
    .followBtn1 {
      background-color: #CCCCCC;
    }
  }
  .doctorItem:not(:last-of-type) {
    margin-bottom: 15px;
  }
  .mescroll {
    position: fixed;
    // top: 83px;
    top: 117px;
    bottom: 0;
    height: auto;
    padding: 15px 12px 0;
    box-sizing: border-box;
    background-color: #F8F8F8;
  }
  .list {
    width: 100%;
    background-color: #FFFFFF;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 10px;
    .item_img {
      position: relative;
      .item_cover {
        display: block;
        width: 100%;
      }
      .playIcon {
        position: absolute;
        right: 12px;
        bottom: 12px;
        width: 30px;
        height: 30px;
      }
      .activityLabel {
        display: inline-block;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 8px;
        color: #FFFFFF;
        background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
        border-radius: 0 0 0 8px;
      }
    }
    .item_content {
      padding: 5px 8px;
      color: #564C47;
      .item_title {
        font-size: 14px;
      }
      .doctor_info {
        font-size: 11px;
        margin-top: 5px;
        span {
          color: #999999;
        }
      }
      .item_time {
        font-size: 12px;
        color: #999999;
        line-height: 24px;
      }
      .item_label {
        display: flex;
        flex-wrap: wrap;
        span {
          display: inline-block;
          height: 20px;
          line-height: 20px;
          border-radius: 2px;
          padding: 0 6px;
          margin-right: 6px;
          margin-bottom: 5px;
          background-color: rgba(255, 73, 98, 0.15);
          font-size: 11px;
          color: #CA001B;
        }
      }
      .item_nums {
        display: flex;
        justify-content: flex-end;
        .nums {
          display: flex;
          align-items: center;
          img {
            width: 12px;
            margin: 0 2px 0 6px;
          }
          span {
            font-size: 11px;
            color: #666666;
          }
        }
      }
    }
  }
  .waterfall_more {
    text-align: center;
    font-size: 12px;
    color: gray;
  }
}
</style>